import { useTheme } from 'styled-components';
import { QuestionStyleTypes, useQuestionStyle } from '../form-runtime-context';

interface RequiredAsteriskProps {
	gapSize?: string;
}

export const RequiredAsterisk = ({ gapSize = '0.5rem' }: RequiredAsteriskProps) => {
	const theme = useTheme();

	const { fontSize } = useQuestionStyle(QuestionStyleTypes.label, {});

	return (
		<span
			style={{
				color: theme.palette.error.main,
				marginLeft: gapSize,
				...(fontSize ? { fontSize: `${typeof fontSize === 'number' ? fontSize : parseFloat(fontSize) * 1.67}px` } : {})
			}}
		>
			*
		</span>
	);
};
